<template>
	<div>
		<SupportBanner />
		<div class="content-zsy" v-loading="loading" style="min-height: 400px;">
			<div class="title-wrap">
				<h3>이벤트</h3>
			</div>
			<div class="status-wrap">
				<el-row>
					<el-col :xs="12" :sm="6">
						<div class="tab" :class="{ 'active': active == 1 }"  @click="onTab(1)">
							전체
						</div>
					</el-col>
					<el-col :xs="12" :sm="6">
						<div class="tab" :class="{ 'active': active == 2 }"  @click="onTab(2)">
							준비중인 이벤트
						</div>
					</el-col>
					<el-col :xs="12" :sm="6">
						<div class="tab"  :class="{ 'active': active == 3 }" @click="onTab(3)">
							진행중인 이벤트
						</div>
					</el-col>
					<el-col :xs="12" :sm="6">
						<div class="tab" :class="{ 'active': active == 4 }"  @click="onTab(4)">
							종료된 이벤트
						</div>
					</el-col>
				</el-row>	
			</div>
			<div class="list-top">
			        <h4>
			            이벤트<span>{{total}}개</span>
			        </h4>
			        <div>
						<el-input v-model="search" @change="changeSearch" placeholder="검색어를 입력해주세요." suffix-icon="el-icon-search"></el-input>
			        </div>
			    </div>
			
			<div class="tab-content" v-if="active==1">
				<el-row >
					<el-col :xs="24" :sm="12" :md="8" class="thumb-col" v-for="(item, index) in list" :key="index">
						<div class="thumb-wrap" @click="onDetails(item.id)">
						    <div class="thumb">
						        <img loading="lazy"  :src="item.activity_image" alt="">
						    </div>
						</div>
						<div class="info" @click="onDetails(item.id)">
							<div class="status">
								<span v-if="item.active ==1" style="color:#333;">준비중인 이벤트</span>
								<span v-else-if="item.active ==2">진행중인 이벤트</span>
								<span v-else-if="item.active ==3" style="color:#bcbcbc;">종료된 이벤트</span>
							</div>
							<div class="date">
								{{item.starttime_format}} ~ {{item.endtime_format}}
							</div>
							<div class="subject">
								{{item.title}}
							</div>
						</div>
					</el-col>
					
					<!-- <el-col :xs="24" :sm="12" :md="8" class="thumb-col" >
						<div class="thumb-wrap" @click="onDetails(9527)" >
						    <div class="thumb">
						        <img loading="lazy"  src="../../assets/list/6f4ef67ed1038d6679965efcf2a03d51.jpg" alt="">
						    </div>
						</div>
						<div class="info" @click="onDetails(9527)">
							<div class="status">
								진행중인 이벤트
							</div>
							<div class="date">
								2024-09-30 ~ 2025-12-31
							</div>
							<div class="subject">쿠팡 로켓그로스 플랜</div>
						</div>
					</el-col>
					<el-col :xs="24" :sm="12" :md="8" class="thumb-col">
						<div class="thumb-wrap" @click="onDetails(4)">
						    <div class="thumb">
						        <img loading="lazy"  src="../../assets/list/6f4ef67ed1038d6679965efcf2a03d51.jpg" alt="">
						    </div>
						</div>
						<div class="info" @click="onDetails(4)">
							<div class="status">
								진행중인 이벤트
							</div>
							<div class="date">
								2024-09-30 ~ 2025-12-31
							</div>
							<div class="subject">쿠팡 로켓그로스 플랜</div>
						</div>
					</el-col> -->
				</el-row>
				
			</div>
			<div class="tab-content" v-if="active==2">
				<el-row >
					<el-col :xs="24" :sm="12" :md="8" class="thumb-col" v-for="(item, index) in list" :key="index">
						<div class="thumb-wrap" @click="onDetails(item.id)">
						    <div class="thumb">
						        <img loading="lazy"  :src="item.activity_image" alt="">
						    </div>
						</div>
						<div class="info" @click="onDetails(item.id)">
							<div class="status" style="color:#333;">
								준비중인 이벤트
							</div>
							<div class="date">
								{{item.starttime_format}} ~ {{item.endtime_format}}
							</div>
							<div class="subject">
								{{item.title}}
							</div>
						</div>
					</el-col>
				</el-row>
			</div>
			<div class="tab-content" v-if="active==3">
				<el-row >
					<el-col :xs="24" :sm="12" :md="8" class="thumb-col" v-for="(item, index) in list" :key="index">
						<div class="thumb-wrap" @click="onDetails(item.id)">
						    <div class="thumb">
						        <img loading="lazy"  :src="item.activity_image" alt="">
						    </div>
						</div>
						<div class="info" @click="onDetails(item.id)">
							<div class="status">
								진행중인 이벤트
							</div>
							<div class="date">
								{{item.starttime_format}} ~ {{item.endtime_format}}
							</div>
							<div class="subject">
								{{item.title}}
							</div>
						</div>
					</el-col>
				</el-row>
			</div>
			<div class="tab-content" v-if="active==4">
				<el-row >
					<el-col :xs="24" :sm="12" :md="8" class="thumb-col" v-for="(item, index) in list" :key="index">
						<div class="thumb-wrap" @click="onDetails(item.id)">
						    <div class="thumb">
						        <img loading="lazy"  :src="item.activity_image" alt="">
						    </div>
						</div>
						<div class="info" @click="onDetails(item.id)">
							<div class="status" style="color:#bcbcbc;">
								 종료된 이벤트
							</div>
							<div class="date">
								{{item.starttime_format}} ~ {{item.endtime_format}}
							</div>
							<div class="subject">
								{{item.title}}
							</div>
						</div>
					</el-col>
				</el-row>
			</div>
			<el-pagination class="page"
			    layout="prev, pager, next"
			    :total="total">
			</el-pagination>
		
		</div>
		
	</div>
</template>

<script>
	import SupportBanner from '../../components/SupportBanner.vue'
	import request from '@/utils/request'
	export default {
		components: {
			SupportBanner,
		},
		data() {
			return {
				loading: true,
				active:1,
				search: '',
				total:0,
				page:1,
				list: []
			}
		},
		created() {
			this.getList()
		},
		methods: {
			getList(){
				this.loading = true
				request.post('/Activity/getActivityList',
					{
						active:this.active,
						search:this.search,
						page:this.page,
					}
				).then(res => {
					this.loading = false
					console.log(res,"列表")
					if(res.code ==1){
						this.total = res.data.total
						this.list= res.data.data
					}
						
				}).catch(() => {
					this.loading = false
				});
				
			},
			onTab(index){
				console.log(index)
				this.active = index
				this.page = 1,
				this.getList()
			},
			onDetails(id){
				console.log(id)
				this.$router.push(`/eventDetails/${id}`)
			},
			changeSearch(value){
				console.log(value,333333333333)
				this.search = value
				this.page = 1
				this.getList()
			}
			
		}
	}
</script>

<style scoped>
	.title-wrap {
	    text-align: center;
	    color: var(--frontground-color);
	    margin-bottom: 60px;
	}
	.title-wrap h3 {
	    font-size: 45px;
	    font-weight: bold;
	    color: var(--frontground-color);
	    margin: 0 0 19px;
	}
	.status-wrap{
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 10px;
		margin: 0 0 50px;
	}
	.status-wrap .tab{
		display: block;
		color: #000;
		font-size: 17px;
		font-weight: 500;
		border: 1px solid #dedede;
		background: #fff;
		border-radius: 14px;
		padding: 9px;
		min-width: 200px;
		text-align: center;
		margin: 0 10px 10px;
		cursor: pointer;
	}
	.status-wrap .active {
	    color: #fff;
	    background-color: var(--main-color);
	    border-color: var(--main-color);
	}
	.list-top {
	    display: flex;
	    align-items: center;
	    justify-content: space-between;
		padding:0 20px;
	    margin-bottom: 40px;
	}
	.list-top h4 {
	    font-size: 30px;
	    font-weight: bold;
	    color: var(--frontground-color);
	    padding: 0;
	    margin: 0;
	}
	.list-top h4 span {
	    color: var(--main-color);
	}
	.tab-content{
		margin: 20px;
	}
	.thumb-col{
		display: flex;flex-direction:column;justify-content: center;align-items: center;
		margin-bottom: 20px;
	}
	.thumb-wrap {
	    position: relative;
	    width: 380px;
	    height: 195px;
	    margin: 0 0 14px;
	    border-radius: 30px;
	    overflow: hidden;
	}
	.thumb-wrap .thumb {
	    width: 100%;
	    height: 100%;
	    display: flex;
	    align-items: center;
	    justify-content: center;
	}
	.thumb-wrap .thumb img {
	    max-width: 100%;
	    max-height: 100%;
	}
	.info .status {
	    color: var(--main-color);
		font-size: 15px;
		font-weight: bold;
	}
	.info .date {
	    font-size: 14px;
	    color: var(--font-color);
	}
	.info .subject {
	    font-size: 20px;
	    font-weight: 500;
	    width: 380px;
	    overflow: hidden;
	    text-overflow: ellipsis;
	    white-space: nowrap;
	}
	.page{
		padding-top: 20px;
		text-align: center;
	}
	/* 分页背景 */
	::v-deep .el-pager li {
		background-color: #121212;
	}
	::v-deep .el-pagination button:disabled {
		background-color: #121212;
	}
	
	@media (min-width: 992px) {
		.content-zsy{
			width: 1270px;
			margin: 2.5rem auto;
		}
	}
	@media (max-width: 768px) {
		.title-wrap{
			margin-top: 20px;
		}
		.title-wrap h3 {
			font-size: 18px;
			font-weight: bold;
			line-height: 23px;
		}
	
		.hidden-xs {
			display: none !important;
		}
	}
</style>